module.exports = __webpack_public_path__ + "fonts/icomoon.dc9dd004.eot";